import React from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import PropTypes from 'prop-types'
import PageLink from '../animations/PageLink'
import Container from '../global/Container'
import NewsletterForm from '../global/NewsletterForm'

const FooterComponent = ({ className, data }) => {
  const footerData = data ? data : {
    footer: {
      heading: 'Placeholder Title',
      body: 'Placeholder text. To edit this content, use the Globals page.'
    },
    newsletter: {
      heading: 'Placeholder heading',
      text: 'Placeholder text. To edit this content, use the Globals page.',
      action: '#'

    }
  }
  return (
    <footer className={className}>
      <Container className="footer__wrapper">
        <div className="footer__body">
          <h2>{footerData.footer.heading}</h2>
          <p>{footerData.footer.body}</p>
          <div className="footer__subscribe">
            <NewsletterForm className="mailing-list-form" section="footer" data={footerData.newsletter} />
          </div>
        </div>
        <div className="footer__menus">
          <dl>
            <dd><PageLink to="/">Home</PageLink></dd>
            <dd><PageLink to="/individuals">For individuals</PageLink></dd>
            <dd><PageLink to="/businesses">For business</PageLink></dd>
            <dd><PageLink to="/schools">For schools &amp; institutions</PageLink></dd>
            <dd><PageLink to="/team">Team</PageLink></dd>
            <dd><PageLink to="/glossary">Glossary</PageLink></dd>
            <dd><PageLink to="/faq">FAQ</PageLink></dd>
          </dl>
          <dl>
            <dd>Contact</dd>
            <dd><a href="mailto:info@bindlesystems.com">info@bindlesystems.com</a></dd>
          </dl>
        </div>
        <div className="footer__copyright">
          © 2020 Bindle Inc. All Rights Reserved.&nbsp;&nbsp;&nbsp;&nbsp;
          <PageLink to="/privacy">Privacy</PageLink>
        </div>
      </Container>
    </footer>
  )
}

FooterComponent.propTypes = {
  className: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
}

const Footer = styled(FooterComponent)`
  ${tw``}
  background-color: #231F20;
  padding: 3rem 0;
  color: #fff;
  position: relative;
  z-index: 100;
  a:visited,
  .footer__menus,
  a {
    color: #a29a95;
    text-decoration: none;
    font-size: 0.9rem;
  }
  a:hover {
    color: #fff;
  }
  .footer__wrapper {
    display: flex;
    flex-wrap: wrap;
  }
  .footer__body {
    width: 40%;
    padding-right: 5rem;
    margin-right: 5rem;
    border-right: 1px solid #7e7774;
    @media (max-width: 1023px) {
      width: 100%;
      border-right: 0;
      margin-right: 0;
      padding-right: 0;
      p {
        font-size: 0.8rem;
      }
    }
    @media (max-width: 639px) {
      width: 100%;
    }
  }
  .footer__menus {
    width: 35%;
    display: flex;
    dl {
      width: 50%;
      dd {
        margin-bottom: 0.5rem;
      }
      a {
        font-size: 0.9rem;
      }
    }
    @media (max-width: 1023px) {
      width: 100%;
    }
    @media (max-width: 639px) {
      border-top: 1px solid #7e7774;
      padding-top: 24px;
    }
  }
  .footer__subscribe {
    color: #111;
    #mc-embedded-subscribe-form {
      display: flex;
      width: 100%;
      .button {
        padding: 0 2rem;
        font-size: 0.8rem;
        font-family: 'Open Sans';
      }
      .mc-field-group {
        width: 60%;
        padding-right: 1rem;
        input {
          padding-left: 1rem;
          background-color: #808080;
        }
      }
      .email {
        width: 100%;
        font-size: 0.8rem;
      }
    }
    @media (max-width: 639px) {
      width: 100%;
      margin-bottom: 40px;
      #mc-embedded-subscribe-form {
        flex-wrap: wrap;
        .mc-field-group {
          padding-right: 0;
          width: 100%;
        }
        .clear,
        .button {
          width: 100%;
        }
      }
    }
  }
  .footer__copyright a,
  .footer__copyright {
    width: 100%;
    font-size: 0.8rem;
  }
`

export default Footer
